import {SET_EXPORT_LOADING, SET_LOADING} from './actionTypes';

const initialState = {
    isLoading: false,
    isExportLoading: false
};

export const loadingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
        case SET_EXPORT_LOADING:
            return {
                ...state,
                isExportLoading: action.payload,
            };
        default:
            return state;
    }
};

